import moment, { Moment } from "moment-timezone";
import { ClasseAtivo } from "../enum";

interface IRentabilidade {
  codigoAtivo: string;
  classeAtivo: ClasseAtivo;
  data: Moment;
  quantidade: number;
  precoMedio: number;
  fechamento: number;
  fechamentoAnterior: number;
  variacao: number;
  peso: number;
}

export interface IRentabilidadeJson extends Omit<IRentabilidade, "data"> {
  data: string;
}

export class Rentabilidade implements IRentabilidade {
  public codigoAtivo!: string;
  public classeAtivo!: ClasseAtivo;
  public data!: Moment;
  public quantidade!: number;
  public precoMedio!: number;
  public fechamento!: number;
  public fechamentoAnterior!: number;
  public variacao!: number;
  public peso!: number;
  constructor(param: IRentabilidade) {
    Object.assign(this, param);
  }
  public static fromJson(json: IRentabilidadeJson) {
    return new Rentabilidade({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}

interface IRentabilidadeBovespa {
  data: Moment;
  fechamento: number;
  variacao: number;
}

export interface IRentabilidadeBovespaJson
  extends Omit<IRentabilidadeBovespa, "data"> {
  data: string;
}

export class RentabilidadeBovespa implements IRentabilidadeBovespa {
  public data!: Moment;
  public fechamento!: number;
  public variacao!: number;
  constructor(param: IRentabilidadeBovespa) {
    Object.assign(this, param);
  }

  public static fromJson(json: IRentabilidadeBovespaJson) {
    return new RentabilidadeBovespa({
      ...json,
      data: moment.tz(json.data, "America/Sao_Paulo"),
    });
  }
}
